module.exports = __webpack_public_path__ + "statics/img/5-6.d7ecd07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/5-6.png
// module id = TxuZ
// module chunks = 1